import { State } from '@/helpers/entities/enums/v2/State';
export class EcommerceProductVariantModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    markAsDeleted() {
        this.state = State.deleted;
    }
}
